<template>

<v-dialog v-model="dialog" width="800px">
  <v-card>
    <v-form ref="updateBkmt" v-model="updBkmt1Valid">
    <p class=".title ma-2">{{bkmt.bkmt_code }} - {{bkmt.taal_code}}</p>


    <v-row no-gutters>
      <v-col class="mx-2">
        <v-text-field v-model="bkmt.bkmt_descriptionLines01" label="Line 1" counter="32" :rules="rules"></v-text-field>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="mx-2">
        <v-text-field v-model="bkmt.bkmt_descriptionLines02" label="Line 2" copunter="32" :rules="rules"></v-text-field>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="mx-2">
        <v-text-field v-model="bkmt.bkmt_descriptionLines03" label="Line 3" counter="32" :rules="rules"></v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col class="mx-2">
        <v-text-field v-model="bkmt.bkmt_descriptionLines04" label="Line 4" counter="32" :rules="rules"></v-text-field>
      </v-col>
    </v-row>
 <v-row no-gutters>
      <v-col class="mx-2">
        <v-text-field v-model="bkmt.bkmt_descriptionLines05" label="Line 5" counter="32" :rules="rules"></v-text-field>
      </v-col>
    </v-row>
 <v-row no-gutters>
      <v-col class="mx-2">
        <v-text-field v-model="bkmt.bkmt_descriptionLines06" label="Line 6" counter="32" :rules="rules"></v-text-field>
      </v-col>
    </v-row>
 <v-row no-gutters>
      <v-col class="mx-2">
        <v-text-field v-model="bkmt.bkmt_descriptionLines07" label="Line 7" counter="32" :rules="rules"></v-text-field>
      </v-col>
    </v-row>
 <v-row no-gutters>
      <v-col class="mx-2">
        <v-text-field v-model="bkmt.bkmt_descriptionLines08" label="Line 8" counter="32" :rules="rules"></v-text-field>
      </v-col>
    </v-row>
 <v-row no-gutters>
      <v-col class="mx-2">
        <v-text-field v-model="bkmt.bkmt_descriptionLines09" label="Line 9" counter="32" :rules="rules"></v-text-field>
      </v-col>
    </v-row>
 <v-row no-gutters>
      <v-col class="mx-2">
        <v-text-field v-model="bkmt.bkmt_descriptionLines10" label="Line 10" counter="32" :rules="rules"></v-text-field>
      </v-col>
    </v-row>
 
 
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" :disabled="!updBkmt1Valid" small @click="saveBkmt">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
    </v-form>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      updBkmt1Valid: false,
      bkmt: {},
      rules: [v => v.length <= 32 || 'Max 32 characters']
    }
  },
  methods: {
    open(bkmt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/task/fin/abn/bkmt/getBkmt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getBkmt"
          },
          getBkmt: {
            bkmt_encrid: bkmt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.bkmt = res.data.getBkmt;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveBkmt() { 
      this.$axios
        .post("ares/json/ares/task/fin/abn/bkmt/saveBkmt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveBkmt"
          },
          saveBkmt: {
            bkmt_encrid: this.bkmt.bkmt_encrid,
            bkmt_descriptionLines01 : this.bkmt.bkmt_descriptionLines01,
            bkmt_descriptionLines02 : this.bkmt.bkmt_descriptionLines02,
            bkmt_descriptionLines03 : this.bkmt.bkmt_descriptionLines03,
            bkmt_descriptionLines04 : this.bkmt.bkmt_descriptionLines04,
            bkmt_descriptionLines05 : this.bkmt.bkmt_descriptionLines05,
            bkmt_descriptionLines06 : this.bkmt.bkmt_descriptionLines06,
            bkmt_descriptionLines07 : this.bkmt.bkmt_descriptionLines07,
            bkmt_descriptionLines08 : this.bkmt.bkmt_descriptionLines08,
            bkmt_descriptionLines09 : this.bkmt.bkmt_descriptionLines09,
            bkmt_descriptionLines10 : this.bkmt.bkmt_descriptionLines10
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/task/fin/abn/bkmt/searchBkmt1');        
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveBkmt.text,
              color: res.data.saveBkmt.color
            }); 
            this.dialog = false;
          }
        })
    }
  }
}
</script>

